module.exports = __webpack_public_path__ + "static/media/eclos-brand-home-img.46a9ef7a.png";